import { render, staticRenderFns } from "./approval-icon.vue?vue&type=template&id=2d031faa&scoped=true"
import script from "./approval-icon.vue?vue&type=script&lang=js"
export * from "./approval-icon.vue?vue&type=script&lang=js"
import style0 from "./approval-icon.vue?vue&type=style&index=0&id=2d031faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d031faa",
  null
  
)

export default component.exports